import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, LoginState, selectLoginState, setLoginError } from '../../../features/login/loginSlice';
import { selectSandbox } from '../../../features/sandbox/sandboxSlice';

export const LoginNextActions: React.FC = () => {
  const state = useSelector(selectLoginState);
  const sandbox = useSelector(selectSandbox);

  const dispatch = useDispatch();

  const onClick = () => {
    if (state.loginState === LoginState.username) {
      state.username.isValid
        ? dispatch(login(state.username.username, sandbox))
        : dispatch(setLoginError({ displayError: true, errorType: 'usernameNotValid' }));
    } else {
      state.email.isValid
        ? dispatch(login(state.email.email, sandbox))
        : dispatch(setLoginError({ displayError: true, errorType: 'emailNotValid' }));
    }
  };

  return (
    <button className="hatters-btn hatters-btn-accent" disabled={state.processing} onClick={() => onClick()}>
      {state.processing ? 'Logging in' : 'Next'}
    </button>
  );
};
